<section>
	<section class="text-align-center margin-top-40">
		<div class="text-28-extra-bold">{{ errorTitle }}</div>
		<div class="text-16 margin-top-10">{{ errorDesc }}</div>
	</section>
</section>
